<script setup>
import { Head, useForm } from '@inertiajs/vue3';
import BreezeButton from '@/Components/Button.vue';
import LandingPageLayout from '@/Layouts/LandingPage.vue';

const props = defineProps({
    companyLogo: String,
    currentAccountingPeriod: String,
    accountingPeriodCloses: String,
    isAccountingPeriodCloseable: Boolean
});

const form = useForm({
});

const submit = () => {
    if(confirm('Are you sure you want to close '.concat(props.currentAccountingPeriod).concat('? This cannot be undone.'))) {
        form.post(route('accounting.periodclose'));
    }
};
</script>

<template>
    <Head title="Accounting Landing" />
    <LandingPageLayout :companyLogo="companyLogo">
      <div class="mt-6 px-7">
        <dl class="grid grid-cols-1 sm:grid-cols-2">
          <div class="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Open Accounting Period: </dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">{{currentAccountingPeriod}}</dd>
        </div>
        <div class="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Period will auto-close on: </dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">{{accountingPeriodCloses}}</dd>
        </div>
        <div v-show="isAccountingPeriodCloseable">
        <form @submit.prevent="submit">
          <div class="border-t border-gray-100 px-4 py-6 sm:col-span-2 sm:px-0">
            <BreezeButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Close Previous Accounting Period
            </BreezeButton>
        </div>
    </form>
</div>
</dl>
</div>

</LandingPageLayout>

</template>
